import { languages } from "../constants/langConstants";

let savedLanguage = JSON.parse(
  localStorage.getItem("language") === "undefined"
    ? null
    : localStorage.getItem("language")
);
const state = {
  languages,
  selectedLocale:
    savedLanguage && savedLanguage.locale ? savedLanguage : languages[0]
};

// getters
const getters = {
  selectedLocale: state => {
    return state.selectedLocale;
  },
  languages: state => {
    return state.languages;
  },
  selectedLocaleUC: state => {
    return jsUcfirst(state.selectedLocale.locale);
  },
  selectedLocaleIndex: state => {
    var selected = 1;
    languages.forEach(function(value, index) {
      if (state.selectedLocale.locale === value.locale) {
        selected = index + 1;
      }
    });
    return selected;
  }
};

// actions
const actions = {
  changeLanguage(context, payload) {
    context.commit("changeLanguageHandler", payload);
  }
};

// mutations
const mutations = {
  changeLanguageHandler(state, language) {
    state.selectedLocale = language;
    //state.rtlLayout = false;
  }
};

function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default {
  state,
  getters,
  actions,
  mutations
};
